import {SELECT_VALUE} from 'constants/VATItems'
import {SOURCE_TYPES} from 'constants/OfferSourceTypes'
import {ITEM_TYPES} from "./itemTypes";


const netGross = {
    grossValue: '',
    value: '',
    vatRate: SELECT_VALUE.DEFAULT,
}

export const newItem = {
    name: '',
    description: '',
    quantity: {
        value: "1",
        uom: 'SZT'
    },
    type: ITEM_TYPES.BASIC,
    offerVatPredefined: false,
    offerSourceType: SOURCE_TYPES.SUPPLIER,
    allowQuantityEditInOffer: false,
}

export const newElement = (identity, demandId) => ({
    identity,
    demandId,
    _edit: true,
    _open: true,
    _touched: true,
    name: null,
    description: '',
    categoryItemCpv: [],
    termOption: "date",
    amount: netGross,
    realizationBeforeOfferAmount: netGross,
    realizationBeforeOfferOptionAmount: netGross,
    publishRealizationBeforeOfferOptionAmount: null,
    items: [newItem],
    stages: [
        {
            conditions: [],
            conditionsInSiwz: true,
            criterions: [],
            parameters: [],
        }
    ],
})


export default [
    newElement(-1),
]
